export default "__VITE_ASSET__JUmWChGk__"